import type {ReactElement} from 'react';
import React from 'react';
import {BaseFillOptions} from '@Panels/poster-editor-text-fill-panel/components/base-fill-options';
import type {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem';

interface TextslideItemFillOptionsProps {
  panelId: string;
  onOpenColorPanel(colorIndex: number): void;
}

export function TextslideItemFillOptions({...props}: TextslideItemFillOptionsProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fillType = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillType');
  const fillColor = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillColor');

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide?.isTextSlide()) {
    return null;
  }

  if (!fillColor || fillType === undefined || activeSlideUID === undefined) {
    return null;
  }

  const onChangeFillType = (newType: FillTypes): void => {
    if (newType === fillType) {
      return;
    }
    const fillObject = {
      fillType: newType,
      fillColor: activeSlide.textStyles.fill.getColorForNewType(newType),
    };
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        fill: {
          ...fillObject,
        },
      },
      list: {
        fill: {
          ...fillObject,
        },
      },
    });
  };

  return (
    <BaseFillOptions
      fillObject={{fillColor, fillType}}
      onOpenColorPanel={(colorIndex): void => {
        props.onOpenColorPanel(colorIndex);
      }}
      panelId={props.panelId}
      onChangeFillType={onChangeFillType}
    />
  );
}
